import { render, staticRenderFns } from "./CustomSortable.vue?vue&type=template&id=661a87bc&scoped=true&"
import script from "./CustomSortable.vue?vue&type=script&lang=js&"
export * from "./CustomSortable.vue?vue&type=script&lang=js&"
import style0 from "./CustomSortable.vue?vue&type=style&index=0&id=661a87bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a87bc",
  null
  
)

export default component.exports